import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  timeWrapper: {
    display: 'flex',
    marginTop: theme.spacing.md,
  },

  timeInput: {
    flex: 1,
    marginRight: theme.spacing.md,
  },
}));
